// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../bundler/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../bundler/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scope message typography to the two assistant composers; task/title inputs
   keep their existing styles. Placeholder wrapping participates in auto-expand
   instead of being clipped by the absolutely positioned Quill placeholder. */
[data-testid='assistant-composer-row'] .ql-editor {
    position: relative;
    min-height: 24px;
    line-height: 24px !important;
    overflow-wrap: anywhere;
}

[data-testid='assistant-composer-row'] .ql-editor > p {
    line-height: 24px;
}

[data-testid='assistant-composer-row'] .ql-editor.ql-blank::before {
    position: static;
    display: block;
    white-space: pre-wrap;
    letter-spacing: normal !important;
    overflow-wrap: anywhere;
    line-height: 24px !important;
}

/* Keep Quill's empty paragraph/caret at the first line without adding a second
   line below the placeholder. The editor's reserved padding clears mic + attach. */
[data-testid='assistant-composer-row'] .ql-editor.ql-blank > p {
    position: absolute;
    top: 0;
    left: 0;
    right: 62px;
}
`, "",{"version":3,"sources":["webpack://./components/MyDayView/AssistantLine/assistantInput.css"],"names":[],"mappings":"AAAA;;6EAE6E;AAC7E;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iCAAiC;IACjC,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;mFACmF;AACnF;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;AACf","sourcesContent":["/* Scope message typography to the two assistant composers; task/title inputs\n   keep their existing styles. Placeholder wrapping participates in auto-expand\n   instead of being clipped by the absolutely positioned Quill placeholder. */\n[data-testid='assistant-composer-row'] .ql-editor {\n    position: relative;\n    min-height: 24px;\n    line-height: 24px !important;\n    overflow-wrap: anywhere;\n}\n\n[data-testid='assistant-composer-row'] .ql-editor > p {\n    line-height: 24px;\n}\n\n[data-testid='assistant-composer-row'] .ql-editor.ql-blank::before {\n    position: static;\n    display: block;\n    white-space: pre-wrap;\n    letter-spacing: normal !important;\n    overflow-wrap: anywhere;\n    line-height: 24px !important;\n}\n\n/* Keep Quill's empty paragraph/caret at the first line without adding a second\n   line below the placeholder. The editor's reserved padding clears mic + attach. */\n[data-testid='assistant-composer-row'] .ql-editor.ql-blank > p {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 62px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
